import { render, staticRenderFns } from "./CcwippLoadingDashboardItem.vue?vue&type=template&id=7f5f78f2&scoped=true&"
import script from "./CcwippLoadingDashboardItem.vue?vue&type=script&lang=js&"
export * from "./CcwippLoadingDashboardItem.vue?vue&type=script&lang=js&"
import style0 from "./CcwippLoadingDashboardItem.vue?vue&type=style&index=0&id=7f5f78f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5f78f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VDivider,VList,VListItem,VListItemContent,VProgressCircular,VRow})
